export default {
	OptionsData: function(state) {
		return state.OptionsData;
	}
};
